import { ClassificationValues } from "../../../interfaces/classification";
import { roundNumber } from "../../../utils/math";

export function mapClassificationColors(values: ClassificationValues, colorRange: string[] = []) {
  if (colorRange.length === 0) {
    return values;
  }

  const lastColor = colorRange[colorRange.length - 1];

  return values.map((value, index) => ({
    ...value,
    parameterValue: colorRange[index] || lastColor,
  }));
}

const NUMBER_VALUE_SCALE = 10;

export const recalcNumberClassificationValues = (
  values: ClassificationValues,
  from: number,
  to: number,
): ClassificationValues => {
  const step = (to - from) / (values.length - 1 || 1) || 1;

  return values.map((value, index) => ({
    ...value,
    parameterValue: roundNumber(from + step * index, NUMBER_VALUE_SCALE),
  }));
};
